import React, {useEffect, useState} from "react";
import BlurLoading from "../../components/BlurLoading";
import PhoneNumber from "libphonenumber-js";
import useCardsAPI from "../../api/CardsAPI";
import NumberInput from "../../components/BankTransfers/NumberInput";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";

function RequestCardTemplate({activeButton}) {

    const [cardInformation, setCardInformation] = useState({
        MobileNo: "",
        NameOnCard: "",
        Email: "",
        LimitPerTransaction: 0,
        LimitPerMonth: 0,
        CashWithdrawals: "yes",
        OnlinePayments: "yes",
        POSPayments: "yes"
    });

    const [errors, setErrors] = useState({});

    const {GetCardInfoByMobileNo, cardInfo} = useCardsAPI();

    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    useEffect(() => {
        if (activeButton.card) {
            setCardInformation({
                CardID: activeButton.card.CardID,
                LimitPerTransaction: activeButton.card.LimitPerTransaction,
                LimitPerMonth: activeButton.card.LimitPerMonth,
                CashWithdrawals: activeButton.card.CashWithdrawals === "Allow" ? "yes" : "no",
                OnlinePayments: activeButton.card.OnlinePayments === "Allow" ? "yes" : "no",
                POSPayments: activeButton.card.POSPayments === "Allow" ? "yes" : "no",
                NameOnCard: activeButton.card.CardName,
                Email: activeButton.card.Email,
                MobileNo: activeButton.card.PhoneNumber
            });
        }
    }, [activeButton.card]);


    useEffect(() => {
        if (cardInfo.Message) {
            setErrors({...errors, MobileNo: cardInfo.Message});
        } else if (!activeButton.card) {
            setErrors({...errors, MobileNo: ""})
            setCardInformation({
                ...cardInformation,
                NameOnCard: cardInfo.NameOnCard,
                Email: cardInfo.Email
            })
        }
    }, [cardInfo]);

    const handlePhoneChange = (event) => {
        const {value} = event.target;

        if (value) {
            const parsedPhoneNumber = PhoneNumber(value, "LB");
            if (parsedPhoneNumber?.isValid()) {
                setCardInformation({...cardInformation, MobileNo: parsedPhoneNumber.nationalNumber});
                GetCardInfoByMobileNo(parsedPhoneNumber.nationalNumber);
            } else {
                setErrors({...errors, MobileNo: "Phone number is invalid."});
                setCardInformation({...cardInformation, NameOnCard: "", Email: ""});
            }
        }
    };

    const handleRadioChange = (event) => {
        const {id, name} = event.target;
        setCardInformation({...cardInformation, [name]: id});
    };


    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setCardInformation({...cardInformation, [name]: value});
    }

    const validate = () => {
        let temp = {};
        temp.MobileNo = errors.MobileNo ?? "";
        temp.NameOnCard = cardInformation.NameOnCard ? "" : "This field is required.";
        temp.LimitPerTransaction = cardInformation.LimitPerTransaction ? "" : "This field is required.";
        temp.LimitPerMonth = (cardInformation.LimitPerMonth) ? "" : "This field is required.";
        setErrors({
            ...temp
        });
        return Object.values(temp).every(x => x === "");
    };

    const handleSubmit = () => {
        if(validate()){
            dispatch(setActionPayload(cardInformation));

            if(activeButton.card){
                dispatch(setActionType(ACTION_TYPES.EDIT_CARD));
            }else{
                dispatch(setActionType(ACTION_TYPES.REQUEST_CARD));
            }
            onOpenQrAfterGenerate();
        }

    }

    return (
        <>
            <div className="RequestCardTemplate">
                {<BlurLoading/>}

                <div className="title">Corporate Card Holder Information</div>
                <div className="RequestCardTemplate">
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Phone Number</div>
                        <div className="col-lg-4 col-md-7">
                            {
                                activeButton.card ?
                                    <input
                                        value={cardInformation.MobileNo}
                                        disabled
                                    />
                                    :
                                    <input
                                        type="number"
                                        name="MobileNo"
                                        placeholder="Phone Number"
                                        onChange={handlePhoneChange}
                                    />
                            }

                            {errors.MobileNo && <div className="error">{errors.MobileNo}</div>}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Name On Card</div>
                        <div className="col-lg-4 col-md-7">
                            <input
                                type="text"
                                value={cardInformation.NameOnCard}
                                name="NameOnCard"
                                placeholder="Name On Card"
                                disabled
                            />
                            {errors.NameOnCard && <div className="error">{errors.NameOnCard}</div>}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Email</div>
                        <div className="col-lg-4 col-md-7">
                            {/*Autofilled*/}
                            <input
                                type="text"
                                placeholder="email@email.com"
                                value={cardInformation.Email}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="title mt-5">Card Settings - Can be edited afterwards</div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Limit per Transaction</div>
                        <div className="col-lg-4 col-md-7">
                            <NumberInput payload={cardInformation} setPayload={setCardInformation} currency={1}
                                         objKey="LimitPerTransaction"
                                         defaultValuee={cardInformation.LimitPerTransaction?.toString()}/>
                            {errors.LimitPerTransaction && <div className="error">{errors.LimitPerTransaction}</div>}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Limit per Month</div>
                        <div className="col-lg-4 col-md-7">
                            <NumberInput payload={cardInformation} setPayload={setCardInformation} currency={1}
                                         objKey="LimitPerMonth"
                                         defaultValuee={cardInformation.LimitPerMonth?.toString()}/>
                            {errors.LimitPerMonth && <div className="error">{errors.LimitPerMonth}</div>}
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Cash Withdrawals</div>
                        <div className="col-lg-4 col-md-7 ps-4">
                            <div className="radio-group">
                                <div className="radio-cont">
                                    <label htmlFor="cashWithdrawals1">Yes</label>
                                    <input type="radio" id="yes" name="CashWithdrawals"
                                           checked={cardInformation?.CashWithdrawals === "yes"}
                                           onChange={handleRadioChange}
                                    />
                                </div>
                                <div className="radio-cont">
                                    <label htmlFor="cashWithdrawals2">No</label>
                                    <input type="radio" id="no" name="CashWithdrawals"
                                           checked={cardInformation.CashWithdrawals === "no"}
                                           onChange={handleRadioChange}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Online Payments</div>
                        <div className="col-lg-4 col-md-7 ps-4">
                            <div className="radio-group">
                                <div className="radio-cont">
                                    <label htmlFor="onlinePayments1">Yes</label>
                                    <input type="radio" id="yes" name="OnlinePayments"
                                           checked={cardInformation?.OnlinePayments === "yes"}
                                           onChange={handleRadioChange}
                                    />
                                </div>
                                <div className="radio-cont">
                                    <label htmlFor="onlinePayments2">No</label>
                                    <input type="radio" id="no" name="OnlinePayments"
                                           checked={cardInformation?.OnlinePayments === "no"}
                                           onChange={handleRadioChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">POS Payments</div>
                        <div className="col-lg-4 col-md-7 ps-4">
                            <div className="radio-group">
                                <div className="radio-cont">
                                    <label htmlFor="posPayments1">Yes</label>
                                    <input type="radio" id="yes" name="POSPayments"
                                           checked={cardInformation?.POSPayments === "yes"}
                                           onChange={handleRadioChange}
                                    />
                                </div>
                                <div className="radio-cont">
                                    <label htmlFor="posPayments2">No</label>
                                    <input type="radio" id="no" name="POSPayments"
                                           checked={cardInformation?.POSPayments === "no"}
                                           onChange={handleRadioChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row submitForm">
                        <div className="btn_place">
                            <button onClick={handleSubmit} className="submitBtn">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RequestCardTemplate;


